import {
    FetchState,
    BirthYearState
} from "@/shared/types";

import * as UserService from "@/shared/api/userService";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: BirthYearState = {
    birthYearFetchState: FetchState.Uninitialized,
    birthYear: 0
};

export const useBirthYearStore = defineStore("birthYear", {
    state: (): BirthYearState => (_.cloneDeep(initialState)),
    getters: {
        birthYearLoaded: state => state.birthYearFetchState === FetchState.Loaded,
    },
    actions: {
        setBirthYearFetchState (fetchState: FetchState) {
            this.birthYearFetchState = fetchState;
        },
        setBirthYear (birthYear: number) {
            this.birthYear = birthYear;
        },
        loadBirthYear (): Promise<any> {
            this.setBirthYearFetchState(FetchState.Loading);
            return UserService.getBirthYear().then(response => {
                this.setBirthYear(response.data.birthYear);
                this.setBirthYearFetchState(FetchState.Loaded);
            }).catch(err => {
                storeHelper.handleError({ error: err, rethrow: false });
            });
        }
    }
});